export default "__VITE_ASSET__3IEwl4aR__"